import { OrderingInitialState, SelectCustomerAction } from '@reducers/ordering/types';

export const setCustomer = (state: OrderingInitialState, action: SelectCustomerAction): OrderingInitialState => ({
  ...state,
  customerState: {
    ...state.customerState,
    customer: action.payload,
    selectedCustomerAddressId: action.payload.addressId,
  },
});
